import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/flat';
import 'core-js/features/array/for-each';
import 'core-js/features/array/from';
import 'core-js/features/array/includes';
import 'core-js/features/object/assign';
import 'core-js/features/object/values';
import 'core-js/features/promise';

// Default stylesheets.
import './normalize.css';
import './style.css';

/**
 * This is a fallback for legacy implementations.
 * Until late 2019 we switched from HashHistory to the browserHistory functionality.
 */
if (window.location.href.indexOf('/#/') > -1) {
    window.location = window.location.href.split('/#/').join('/');
}

import injectTapEventPlugin from 'react-tap-event-plugin';

/**
 * Needed for onTouchTap & version Material-UI v0.17.4
 * http://stackoverflow.com/a/34015469/988941
 */
injectTapEventPlugin();

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import EnvironmentHelper from 'helpers/environment';
import * as SentryLogging from 'helpers/Logging/sentry';

if (EnvironmentHelper.resolveEnvironment() !== EnvironmentHelper.ENV_LOCAL) {
    SentryLogging.configure();
}

ReactDOM.render(
    <App />,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js